import { searchPromotedEvents } from '@eventbrite/api-clients';
import { sdkRequest } from '@eventbrite/http';
import { EventBasicInformation } from '../../contexts/EventContext';

const RELATED_PROMOTED_EVENTS_RADIUS_IN_MILES = 50;

export function searchEventRelatedPromotedEvents(event: EventBasicInformation) {
    const { isOnline, latitude, longitude, placeId } = event.place;
    const geo_point =
        isOnline || !latitude || !longitude
            ? undefined
            : {
                  lat: latitude,
                  lon: longitude,
                  radius: RELATED_PROMOTED_EVENTS_RADIUS_IN_MILES,
              };

    return searchPromotedEvents({
        slots: 1,
        page: 1,
        interface: 'related_events',
        search: {
            dates: ['current_future'],
            related_event: {
                id: event?.id,
                name: event?.name,
                summary: event?.summary,
            },
            place: {
                is_online: event.place.isOnline,
                geo_point,
                place_id: placeId,
            },
        },
    });
}

export async function searchLegacyEventRelatedPromotedEvents(
    eventInfo: EventBasicInformation,
) {
    const expansions = [
        'image',
        'primary_venue',
        'ticket_availability',
        'saves',
        'primary_organizer',
    ].join(',');

    const response = await sdkRequest(
        `/api/v3/destination/events/${eventInfo.id}/related/?include_promoted_events=true&expand=${expansions}`,
    );

    return response.promoted_events;
}
